import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["animation"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BasicSkeleton } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ProductBoxSkeleton = function ProductBoxSkeleton(_ref) {
  var _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? 'pulse' : _ref$animation,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx(BasicSkeleton, {
      animation: animation,
      height: 210
    }), /*#__PURE__*/_jsx(BasicSkeleton, {
      variant: "text",
      height: 19,
      width: "60%",
      animation: animation,
      style: {
        marginTop: '18px'
      }
    }), /*#__PURE__*/_jsx(BasicSkeleton, {
      variant: "text",
      height: 19,
      width: "40%",
      animation: animation,
      style: {
        marginTop: '8px'
      }
    }), /*#__PURE__*/_jsx(BasicSkeleton, {
      variant: "text",
      height: 25,
      width: "65px",
      animation: animation,
      style: {
        marginTop: '38px'
      }
    })]
  }));
};
//# sourceMappingURL=ProductBoxSkeleton.js.map